const initialState = false;

const successToastReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'success/show':
			return action.payload;
		case 'success/hide':
			return initialState;
		default:
			return state !== undefined ? state : null;
	}
};

export default successToastReducer;
